import { render, staticRenderFns } from "./ShipOrder.vue?vue&type=template&id=1c5e111a&scoped=true"
import script from "./ShipOrder.vue?vue&type=script&lang=js"
export * from "./ShipOrder.vue?vue&type=script&lang=js"
import style0 from "./ShipOrder.vue?vue&type=style&index=0&id=1c5e111a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5e111a",
  null
  
)

export default component.exports